module.exports = __webpack_public_path__ + "assets/media/1.e2373dfc.wav";